import {resetSideDrawer} from "@/functions/getModal";

const setBusy = (isBusy) => {
	const content = document.getElementById('mainContentArea')
	const status = document.getElementById('pageStatus')
	if (isBusy) {
		content?.setAttribute('aria-busy', 'true')
		if (status) status.textContent = 'Loading…'
	} else {
		content?.removeAttribute('aria-busy')
	}
}

const getLoading = () => {
    const showLoading = () => {
		let loadingScreen = document.getElementById('loadingScreen')

	    resetSideDrawer()

	    if (loadingScreen.classList.contains('d-none')) {
		    loadingScreen.classList.remove('d-none')
		    scrollTo(0,0)
	    }
	    setBusy(true)
    }
    const hideLoading = () => {
	    let loadingScreen = document.getElementById('loadingScreen')
	    if (!loadingScreen.classList.contains('d-none')) {
		    setTimeout(() => {
			    loadingScreen.classList.add('d-none')
			    setBusy(false)
		    }, 250)
	    }
    }

    return {
        showLoading,
        hideLoading
    }
}

export default getLoading